export default __webpack_public_path__ + "static/media/fertility-icon.29f058ed.svg";